import { useConversationEditorConfig } from '@modules/conversation/hooks/useConversationEditorConfig';
import { useEditor } from '@modules/editor';
import EmptyContent from 'src/components/empty-content';
import Scrollbar from 'src/components/scrollbar';
import { SkeletonConversationItem } from 'src/components/skeleton';
import { useMentionsQuery } from '../useMentionsQuery';
import { UserMentionItem } from './UserMentionItem';

const ITEM_HEIGHT = 78;

export const UserMentionsList = () => {
  const { mentions, isFetching } = useMentionsQuery();

  const { editorConfig } = useConversationEditorConfig({
    handleChatUploadFile: () => {},
    //? it's okay because user can mention anyone here
    participants: [],
  });

  //? this is not a ideal solution
  // TODO: we need to message render to take just the extensions so it can call @tiptap/core generateJSON without having to load the whole editor
  const { editor, editorLoaded } = useEditor(editorConfig);

  if (isFetching) {
    return (
      <>
        <SkeletonConversationItem />
        <SkeletonConversationItem />
      </>
    );
  }

  if (!mentions) {
    return (
      <EmptyContent
        sx={{ height: 300 }}
        title="No mentions"
        description="No one mentioned you."
        img="/assets/illustrations/illustration_empty_content.svg"
      />
    );
  }

  if (!editorLoaded) return null;

  return (
    <Scrollbar sx={{ maxHeight: ITEM_HEIGHT * 4, height: 'auto' }}>
      {mentions.map((item) => (
        <UserMentionItem
          key={item.result._id}
          mention={item.result}
          readed={item.readed}
          type={item.type}
          editor={editor}
        ></UserMentionItem>
      ))}
    </Scrollbar>
  );
};
